import { render, staticRenderFns } from "./ObjetivoResponsavel.vue?vue&type=template&id=5026982f&scoped=true"
import script from "./ObjetivoResponsavel.vue?vue&type=script&lang=js"
export * from "./ObjetivoResponsavel.vue?vue&type=script&lang=js"
import style0 from "./ObjetivoResponsavel.vue?vue&type=style&index=0&id=5026982f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5026982f",
  null
  
)

export default component.exports